// One Firebase app for the whole site. Import { db } from here; a second
// initializeApp() call anywhere else will throw at page load.
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDRJAiVjjBBHwVbaBqiboN5V0V20r0UV7g",
  authDomain: "tap-in-a8214.firebaseapp.com",
  projectId: "tap-in-a8214",
  storageBucket: "tap-in-a8214.appspot.com",
  messagingSenderId: "1048095297806",
  appId: "1:1048095297806:web:954684537b548a8730475f",
  measurementId: "G-CG7XTDX5DE",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
